import { IAuthenticationStore } from '../../core/Abstractions/IAuthenticationStore';

export async function logout(store: IAuthenticationStore) {
  await store.logout();

  window.location.assign('/account/login');
}
